import { red } from "@mui/material/colors";
import { color } from "@mui/system";
import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { BiEditAlt } from "react-icons/bi";
import { useNavigate } from "react-router";
import { ApiRequestPost } from "../../../../../data/network/services/ApiRequestPost";
import secureStorage from "../../../../../services/secureStorage";
import {
  colorBlack,
  colorWhite,
  primaryColor,
} from "../../../../../utility/constants/colorManager";
import { SS_ROLE } from "../../../../../utility/constants/secureStorageManager";
import {
  ADMIN_USER,
  CLIENT_EDIT_ACL,
  OPERATIONS,
  RUPEES,
  STATUS_CODE_200,
  SUPPORT,
} from "../../../../../utility/constants/valueConstants";
import { CustomButton } from "../../../../components/main_comps/custom_button";
import { CustomInput } from "../../../../components/main_comps/custom_input/CustomInput";
import { useSelector } from "react-redux";

const Container = ({
  title,
  value,
  style1,
  style2,
  edit,
  color,
  data,
  update,
  val,
}) => {
  const [regex, setRegex] = useState("");

  return (
    <div style={{ display: "flex", marginBottom: "20px", lineHeight: 2 }}>
      <p
        style={{
          color: "#000000",
          fontSize: "14px",
          fontWeight: "500",
          width: "180px",
          ...style1,
        }}
      >
        {title}
      </p>
      {!edit && value !== "undefined" && (
        <>
          <p
            style={{
              color: "#3A3A3A",
              fontSize: "14px",
              //textTransform: "capitalize",
              ...style2,
              minWidth: "120px",
              maxWidth: "180px",
              wordWrap: "break-word",
            }}
          >
            {value}
          </p>
        </>
      )}

      {edit && title !== "Notify url" && (
        <>
          <CustomInput
            inputcomponentStyles={{ ...inputStyle }}
            placeholder=""
            validator="percentageDecimal"
            type="input"
            inputStyles={{
              ...containerStyle,
            }}
            onChange={(val) => {
              update(val);
              setRegex(val);
            }}
            value={regex}
          />
        </>
      )}
      {edit && title === "Notify url" && (
        <>
          <CustomInput
            inputcomponentStyles={{ ...inputStyle }}
            placeholder=""
            type="input"
            inputStyles={{
              ...containerStyle,
            }}
            onChange={(val) => {
              update(val);
              setRegex(val);
            }}
            value={regex}
          />
        </>
      )}
    </div>
  );
};

const inputStyle = {
  alignSelf: "center",
  height: "auto",
  boxShadow: "none",
  outline: "none",
  paddingLeft: 10,
  boxSizing: "border-box",
  backgroundColor: "#FCFCFC",
  color: "black",

  //minWidth: 100,
};
const containerStyle = {
  padding: 0,
  maxWidth: 120,
  height: "auto",
  border: "1px solid #D3D3D3",
  borderRadius: "4px",
};

const OtherDetails = ({ data1, isEditClicked }) => {
  const [resellerName, setResellerName] = useState("");
  const [edit, setEdit] = useState(false);
  const [currentId, setCurrentId] = useState(null);
  const [loading, setLoading] = useState(false);
  const aclData = useSelector((state) => state.aclSlice.aclList);
  const [newServiceObj, setNewServiceObj] = useState([]);
  const [service, setService] = useState([]);

  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const role = secureStorage.getItem(SS_ROLE);

  const updateRate = () => {
    ApiRequestPost.updateRate({
      clientId: data1?.userId,
      service: newServiceObj,
      ipWhitelist: "",
    })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          enqueueSnackbar(res.message, {
            variant: "success",
          });

          navigate("/clients");
        } else {
          enqueueSnackbar(res.message, {
            variant: "error",
          });
        }
      })
      .catch((err) => {
        enqueueSnackbar(err.message, {
          variant: "error",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    setResellerName(data1?.resellerName);
  }, [resellerName]);

  const updatingService = () => {
    const notifyUrlMap = new Map(
      data1.programs
        .map((program) => {
          if (
            program.service_type === "payin" &&
            (program.mechanism === "qr" || program.mechanism === "vba")
          ) {
            return [program.service_type, program.notifyUrl];
          } else if (program.service_type === "voucher") {
            return [program.service_type, program.notifyUrl];
          } else if (program.service_type === "payout") {
            return [program.service_type, program.notifyUrl];
          } else if (program.service_type === "van") {
            return [program.service_type, program.notifyUrl];
          } else {
            return null; // Return null if the condition doesn't match
          }
        })
        .filter((entry) => entry !== null) // Filter out null entries
    );

    const notifyUrls = data1.service.map((service) =>
      notifyUrlMap.get(service.serviceType)
    );

    const updatedService = [...data1.service];

    notifyUrls.forEach((notifyUrl, index) => {
      updatedService[index] = {
        ...updatedService[index],
        notifyUrl: notifyUrl,
      };
    });

    return updatedService;
  };

  useEffect(() => {
    let newServices = updatingService();
    setService(newServices);
  }, [data1]);

  return (
    <>
      <div>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "20px 250px",
            marginTop: 50,
            minWidth: "550px",
            height: "auto",
          }}
        >
          {service.length > 0 &&
            service?.map((data, i) => (
              <div
                style={{
                  marginLeft: 20,
                }}
              >
                <div
                  style={{
                    border: "1px solid #E2E2E2",
                    padding: "10px",
                    paddingRight: "50px",
                    borderRadius: "12px",
                    paddingTop: "15px",
                  }}
                >
                  {currentId !== i && aclData?.includes(CLIENT_EDIT_ACL) && (
                    <>
                      <CustomButton
                        ionDirection="left"
                        icon={<BiEditAlt size={16} color="white" />}
                        styles={{
                          marginLeft: "80%",
                          marginBottom: "10px",
                        }}
                        title={"Edit"}
                        textStyles={{
                          color: isEditClicked ? "#1E2234" : "white",
                        }}
                        onClick={() => {
                          setEdit(true);
                          setCurrentId(i);
                        }}
                      />
                    </>
                  )}
                  {currentId === i && edit && (
                    <>
                      <div
                        style={{
                          display: "flex",
                          marginLeft: "38%",
                          gap: "25px",
                          marginBottom: "10px",
                        }}
                      >
                        <CustomButton
                          title="Cancel"
                          styles={{
                            backgroundColor: colorWhite,
                            border: "1px solid black",
                          }}
                          textStyles={{
                            color: colorBlack,
                          }}
                          onClick={() => {
                            setEdit(false);
                            setCurrentId(null);
                            let newServices = updatingService();
                            setService(newServices);
                          }}
                        />
                        <CustomButton
                          title={"Save"}
                          textStyles={{
                            color: isEditClicked ? "#1E2234" : "white",
                          }}
                          onClick={() => {
                            if (
                              newServiceObj[0]?.comissionRate[0]?.value[
                                newServiceObj[0]?.comissionRate[0]?.value
                                  ?.length - 1
                              ] === "."
                            ) {
                              enqueueSnackbar(
                                "Please enter valid client rate",
                                {
                                  variant: "error",
                                }
                              );
                              return;
                            }
                            if (
                              newServiceObj[0]?.resellerRate[
                                newServiceObj[0]?.resellerRate?.length - 1
                              ] === "."
                            ) {
                              enqueueSnackbar(
                                "Please enter valid reseller rate",
                                {
                                  variant: "error",
                                }
                              );
                              return;
                            }
                            if (
                              newServiceObj[0]?.neokredRate[
                                newServiceObj[0]?.neokredRate?.length - 1
                              ] === "."
                            ) {
                              enqueueSnackbar(
                                "Please enter valid Neokred rate",
                                {
                                  variant: "error",
                                }
                              );
                              return;
                            }

                            updateRate();
                          }}
                        />
                      </div>
                    </>
                  )}

                  <div
                    style={{
                      backgroundColor: "#FFD596",
                      padding: "10px 0px 10px 25px",
                      borderRadius: 5,
                      marginBottom: 20,
                    }}
                  >{`${data?.serviceProviderName} (${data?.serviceType})`}</div>
                  <Container title="Reseller name" value={resellerName} />
                  <Container
                    title="Client rate"
                    value={
                      data?.comissionRate[0]?.type === RUPEES
                        ? `₹ ${data?.comissionRate[0]?.value}`
                        : `${data?.comissionRate[0]?.value}%`
                    }
                    edit={edit && currentId === i}
                    update={(val) => {
                      let serviceProviderName =
                        data?.serviceProviderName.toUpperCase();
                      let serviceType = data?.serviceType?.toUpperCase();

                      let currentProgram = data1?.programs?.find(
                        (e) =>
                          e?.serviceProviderName?.toUpperCase() ===
                            serviceProviderName &&
                          e?.service_type?.toUpperCase() === serviceType
                      );

                      const svcIndex = service.findIndex(
                        (obj) =>
                          obj.serviceProviderName ===
                            data.serviceProviderName &&
                          obj.serviceType === data.serviceType
                      );

                      let svc = service;

                      svc[svcIndex] = {
                        serviceProviderName: data?.serviceProviderName,
                        serviceType: data?.serviceType,
                        serviceProviderRate: data?.serviceProviderRate,
                        resellerRate: data?.resellerRate,
                        neokredRate: data?.neokredRate,
                        comissionType: data?.comissionType,
                        comissionRate: [
                          {
                            from: "",
                            to: "",
                            value: val,
                            type: data?.comissionRate?.[0]?.type,
                          },
                        ],
                      };

                      setService([...svc]);

                      // need to send to the api
                      setNewServiceObj([
                        {
                          serviceProviderName: data?.serviceProviderName,
                          serviceProviderType: data?.serviceType,
                          program_id: currentProgram?.program_id,
                          neokredRate: data?.neokredRate,
                          resellerRate: data?.resellerRate,
                          comissionType: data?.comissionType,
                          comissionRate: [
                            {
                              from: "",
                              to: "",
                              value: val,
                              type: data?.comissionRate?.[0]?.type,
                            },
                          ],
                        },
                      ]);
                    }}
                  />
                  <Container
                    title="Reseller Rate"
                    value={`${data?.resellerRate}%`}
                    edit={edit && currentId === i}
                    update={(val) => {
                      let serviceProviderName =
                        data?.serviceProviderName.toUpperCase();
                      let serviceType = data?.serviceType?.toUpperCase();
                      let currentProgram = data1?.programs?.find(
                        (e) =>
                          e?.serviceProviderName?.toUpperCase() ===
                            serviceProviderName &&
                          e?.service_type?.toUpperCase() === serviceType
                      );

                      // const svcIndex = service.findIndex(
                      //   (obj) =>
                      //     obj.serviceProviderName === data.serviceProviderName
                      // );
                      const svcIndex = service.findIndex(
                        (obj) =>
                          obj.serviceProviderName ===
                            data.serviceProviderName &&
                          obj.serviceType === data.serviceType
                      );

                      let svc = service;

                      svc[svcIndex] = {
                        serviceProviderName: data?.serviceProviderName,
                        serviceType: data?.serviceType,
                        serviceProviderRate: data?.serviceProviderRate,
                        comissionType: data?.comissionType,
                        resellerRate: val,
                        neokredRate: data?.neokredRate,
                        comissionRate: data?.comissionRate,
                      };

                      setService([...svc]);

                      // for api call

                      setNewServiceObj([
                        {
                          serviceProviderName: data?.serviceProviderName,
                          serviceProviderType: data?.serviceType,
                          comissionType: data?.comissionType,
                          program_id: currentProgram?.program_id,
                          neokredRate: data?.neokredRate,
                          resellerRate: val,
                          comissionRate: data?.comissionRate,
                        },
                      ]);
                    }}
                  />
                  <Container
                    title="Neokred Rate"
                    value={`${data?.neokredRate}%`}
                    edit={edit && currentId === i}
                    update={(val) => {
                      let serviceProviderName =
                        data?.serviceProviderName.toUpperCase();
                      let serviceType = data?.serviceType?.toUpperCase();
                      let currentProgram = data1?.programs?.find(
                        (e) =>
                          e?.serviceProviderName?.toUpperCase() ===
                            serviceProviderName &&
                          e?.service_type?.toUpperCase() === serviceType
                      );

                      const svcIndex = service.findIndex(
                        (obj) =>
                          obj.serviceProviderName ===
                            data.serviceProviderName &&
                          obj.serviceType === data.serviceType
                      );
                      let svc = service;

                      svc[svcIndex] = {
                        serviceProviderName: data?.serviceProviderName,
                        serviceType: data?.serviceType,
                        comissionType: data?.comissionType,
                        serviceProviderRate: data?.serviceProviderRate,
                        resellerRate: data?.resellerRate,
                        neokredRate: val,
                        comissionRate: data?.comissionRate,
                      };

                      setService([...svc]);

                      setNewServiceObj([
                        {
                          serviceProviderName: data?.serviceProviderName,
                          serviceProviderType: data?.serviceType,
                          program_id: currentProgram?.program_id,
                          comissionType: data?.comissionType,
                          neokredRate: val,
                          resellerRate: data?.resellerRate,
                          comissionRate: data?.comissionRate,
                        },
                      ]);
                    }}
                  />
                  <Container
                    title={"Service Provider Rate"}
                    value={`${data?.serviceProviderRate}%`}
                    style2={{
                      opacity: edit && currentId === i ? 0.3 : "",
                    }}
                  />

                  <Container
                    title="Notify url"
                    style2={{}}
                    value={`${data?.notifyUrl}`}
                    edit={edit && currentId === i}
                    update={(val) => {
                      let serviceProviderName =
                        data?.serviceProviderName.toUpperCase();
                      let serviceType = data?.serviceType?.toUpperCase();
                      let currentProgram = data1?.programs?.find(
                        (e) =>
                          e?.serviceProviderName?.toUpperCase() ===
                            serviceProviderName &&
                          e?.service_type?.toUpperCase() === serviceType
                      );

                      const svcIndex = service.findIndex(
                        (obj) =>
                          obj.serviceProviderName ===
                            data.serviceProviderName &&
                          obj.serviceType === data.serviceType
                      );
                      let svc = service;

                      svc[svcIndex] = {
                        serviceProviderName: data?.serviceProviderName,
                        serviceType: data?.serviceType,
                        comissionType: data?.comissionType,
                        serviceProviderRate: data?.serviceProviderRate,
                        resellerRate: data?.resellerRate,
                        neokredRate: data?.neokredRate,
                        comissionRate: data?.comissionRate,
                        notifyUrl: val,
                      };

                      setService([...svc]);

                      setNewServiceObj([
                        {
                          serviceProviderName: data?.serviceProviderName,
                          serviceProviderType: data?.serviceType,
                          program_id: currentProgram?.program_id,
                          comissionType: data?.comissionType,
                          neokredRate: data?.neokredRate,
                          resellerRate: data?.resellerRate,
                          comissionRate: data?.comissionRate,
                          notifyUrl: val,
                        },
                      ]);
                    }}
                  />
                </div>
              </div>
            ))}
        </div>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",

            gap: " 0 285px",
            marginLeft: "25px",
            marginTop: "20px",
          }}
        >
          {data1?.programs?.map((e, i) => {
            return (
              <>
                <div>
                  {(role === OPERATIONS ||
                    role === SUPPORT ||
                    role === ADMIN_USER) && (
                    <>
                      {e.service_type === "payin" && (
                        <>
                          <Container
                            title="Payin-Mechanism:"
                            value={e.mechanism}
                            style2={{
                              textTransform: "lowercase",
                            }}
                          />
                        </>
                      )}

                      {e.service_type === "payout" && (
                        <>
                          <Container
                            title="Payout-Mechanism:"
                            value={e.mechanism}
                            style2={{
                              textTransform: "lowercase",
                            }}
                          />
                        </>
                      )}

                      {e.service_type === "van" && (
                        <>
                          <Container
                            title="Mechanism:"
                            value={e.mechanism}
                            style2={{
                              textTransform: "lowercase",
                            }}
                          />
                        </>
                      )}

                      <Container
                        title="Service Provider Name"
                        value={e?.serviceProviderName}
                        style2={{
                          textTransform: "lowercase",
                        }}
                      />

                      <Container
                        title="Client Secret:"
                        value={data1?.userId}
                        style2={{
                          textTransform: "lowercase",
                        }}
                      />
                      <Container
                        title="Program Id:"
                        value={e.program_id}
                        style2={{
                          textTransform: "lowercase",
                        }}
                      />
                    </>
                  )}
                </div>
              </>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default OtherDetails;
